import { render, staticRenderFns } from "./restrictiveIconComponent.vue?vue&type=template&id=89576de4"
import script from "./restrictiveIconComponent.vue?vue&type=script&lang=ts"
export * from "./restrictiveIconComponent.vue?vue&type=script&lang=ts"
import style0 from "./restrictiveIconComponent.vue?vue&type=style&index=0&id=89576de4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports